import * as LoaderAction from '../actions/loader.action';
import {Page} from '../actions/loader.action';

export interface LoaderReducerInterFace {
    loaderState: boolean;
}

const initialState: LoaderReducerInterFace = {
    loaderState: false
};

export function loaderReducer(state: LoaderReducerInterFace = initialState, action: LoaderAction.Actions) {
    if (action.type === Page.loader) {
       return  {...state, ...action.payload};
    } else {
        return state;
    }
}
